module.exports = __webpack_public_path__ + "img/预留男女.dd717df2.webp";